// extracted by mini-css-extract-plugin
export default {"mySelect":"MySelect_mySelect__-Gzjz"};